export const ROLES = {
  BROADCASTER: "broadcaster",
  HOST: "host",
  VIEWER: "viewer",
  CONTROLLER: "controller",
};
export const STATUS = {
  NOT_CONNECTED: 0,
  CONNECTED: 1,
};
export const CURSOR = {
  DEFAULT: `url(${require("@/assets/icons/cursor.svg")}) 25 25, auto`,
  MOVE: "move",
};
export const MODALS = {
  QUESTION: "QuestionModal",
  INFORMATION: "InformationModal",
  NOTIFICATION: "NotificationModal",
  PROMPT: "PromptModal",
};

export const CHARCODE = {
  COMMAND: 91,
  CHAR_V: 86,
  SHIFT: 16,
  BACKSPACE: 8,
  ANDROID_BACKSPACE: 67,
  ENTER: 13,
  ANDROID_ENTER: 66,
  IOS_ENTER: "\n",
  IOS_BACKSPACE: "\b",
  CHAR_TR_C: "¾",
  CHAR_EN_C: "c",
  CHAR_TR_G: "û",
  CHAR_EN_G: "g",
  CHAR_TR_U: "ý",
  CHAR_EN_U: "u",
  CHAR_TR_S: "º",
  CHAR_EN_S: "s",
  CHAR_TR_I: "Þ",
  CHAR_EN_I: "i",
  CHAR_TR_O: "¼",
  CHAR_EN_O: "o",
  replaceKey: (key) => {
    switch (key) {
      case CHARCODE.CHAR_TR_C:
        return CHARCODE.CHAR_EN_C;
      case CHARCODE.CHAR_TR_G:
        return CHARCODE.CHAR_EN_G;
      case CHARCODE.CHAR_TR_O:
        return CHARCODE.CHAR_EN_O;
      case CHARCODE.CHAR_TR_U:
        return CHARCODE.CHAR_EN_U;
      case CHARCODE.CHAR_TR_I:
        return CHARCODE.CHAR_EN_I;
      case CHARCODE.CHAR_TR_S:
        return CHARCODE.CHAR_EN_S;
      default:
        return key;
    }
  },
};

export let STATUS_LIST = [
  {
    number: 1,
    text: "filter.status.available",
  },
  {
    number: 2,
    text: "filter.status.busy",
  },
  {
    number: 3,
    text: "filter.status.offline",
  },
  {
    number: 4,
    text: "filter.status.utilizing",
  },
];

export const ICE_CONFIG = {
  iceServers: [
    {
      urls: process.env.VUE_APP_STUN_SERVER,
    },
    {
      urls: process.env.VUE_APP_TURN_SERVER,
      username: process.env.VUE_APP_TURN_SERVER_USER,
      credential: process.env.VUE_APP_TURN_SERVER_CREDENTIAL,
    },
  ],
};

export let DEVICE_FILTERS = {
  STATUS_OPTIONS: [
    {
      value: 1,
      text: "filter.status.available",
      html: "<div class='status-ball success'></div>",
    },
    {
      value: 2,
      text: "filter.status.busy",
      html: "<div class='status-ball error'></div>",
    },
    {
      value: 3,
      text: "filter.status.offline",
      html: "<div class='status-ball cancel'></div>",
    },
    {
      value: 4,
      text: "filter.status.utilizing",
      html: "<div class='status-ball warning'></div>",
    },
  ],
  OS_OPTIONS: [
    { value: "ios", text: "iOS" },
    { value: "android", text: "Android" },
    { value: "harmonyos", text: "HarmonyOS" },
  ],
  DEVICE_OPTIONS: [
    { value: "phone", text: "filter.type.phone" },
    { value: "tablet", text: "filter.type.tablet" },
  ],
  BRAND_OPTIONS: [
    { value: "Apple", text: "Apple" },
    { value: "Samsung", text: "Samsung" },
    { value: "Xiaomi", text: "Xiaomi" },
    { value: "Huawei", text: "Huawei" },
    { value: "Oppo", text: "Oppo" },
    { value: "General Mobile", text: "General Mobile" },
  ],
  OSV_OPTIONS: [
    { value: "13.0.6", text: "Android 13.0.6" },
    { value: "13.0.0", text: "Android 13.0.0" },
    { value: "12.0.0", text: "Android 12.0.0" },
    { value: "11.0.0", text: "Android 11.0.0" },
    { value: "10.0.0", text: "Android 10.0.0" },
    { value: "9.0.0", text: "Android 9.0.0" },
    { value: "8.1.0", text: "Android 8.1.0" },
    { value: "16.4.1 (a)", text: "iOS 16.4.1 (a)" },
    { value: "16.4.1", text: "iOS 16.4.1" },
    { value: "16.3.1", text: "iOS 16.3.1" },
    { value: "16.3.0", text: "iOS 16.3.0" },
    { value: "16.1.0", text: "iOS 16.1.0" },
    { value: "15.4.1", text: "iOS 15.4.1" },
    { value: "15.3.1", text: "iOS 15.3.1" },
    { value: "15.0.2", text: "iOS 15.0.2" },
  ],
  RESOLUTION_OPTIONS: [
    { value: "1620 x 2160", text: "1620 x 2160" },
    { value: "1536 x 2048", text: "1536 x 2048" },
    { value: "1440 x 3200", text: "1440 x 3200" },
    { value: "1284 x 2778", text: "1284 x 2778" },
    { value: "1242 x 2688", text: "1242 x 2688" },
    { value: "1200 x 1920", text: "1200 x 1920" },
    { value: "1179 x 2556", text: "1179 x 2556" },
    { value: "1170 x 2532", text: "1170 x 2532" },
    { value: "1140 x 2960", text: "1140 x 2960" },
    { value: "1125 x 2436", text: "1125 x 2436" },
    { value: "1080 x 2408", text: "1080 x 2408" },
    { value: "1080 x 2400", text: "1080 x 2400" },
    { value: "1080 x 2340", text: "1080 x 2340" },
    { value: "1080 x 2280", text: "1080 x 2280" },
    { value: "1080 x 1920", text: "1080 x 1920" },
    { value: "750 x 1334", text: "750 x 1334" },
    { value: "720 x 1600", text: "720 x 1600" },
    { value: "720 x 1520", text: "720 x 1520" },
    { value: "720 x 1440", text: "720 x 1440" },
    { value: "720 x 1080", text: "720 x 1080" },
  ],
  SIZE_OPTIONS: [
    { value: '10.50"', text: '10.50"' },
    { value: '10.20"', text: '10.20"' },
    { value: '7.90"', text: '7.90"' },
    { value: '6.70"', text: '6.70"' },
    { value: '6.67"', text: '6.67"' },
    { value: '6.60"', text: '6.60"' },
    { value: '6.55"', text: '6.55"' },
    { value: '6.50"', text: '6.50"' },
    { value: '6.43"', text: '6.43"' },
    { value: '6.40"', text: '6.40"' },
    { value: '6.30"', text: '6.30"' },
    { value: '6.20"', text: '6.20"' },
    { value: '6.10"', text: '6.10"' },
    { value: '5.80"', text: '5.80"' },
    { value: '5.70"', text: '5.70"' },
    { value: '5.50"', text: '5.50"' },
    { value: '5.40"', text: '5.40"' },
    { value: '5.00"', text: '5.00"' },
    { value: '4.70"', text: '4.70"' },
  ],
  NFC_OPTIONS: [
    { value: true, text: "filter.general.yes" },
    { value: false, text: "filter.general.no" },
  ],
};
export let APP_FILTERS = {
  EXTENSION_OPTIONS: [
    { value: "ipa", text: "filter.extension.ipa" },
    { value: "apk", text: "filter.extension.apk" },
    { value: "aab", text: "filter.extension.aab" },
  ],
};
export const LABEL_COLORS = [
  "#FD7070",
  "#FA881F",
  "#019950",
  "#6251CC",
  "#BF6FFA",
  "#0C4FFB",
  "#22C55E",
  "#DB2FFF",
];

export const FORM_ID_LIST = {
  BUSINESS_ANNUAL: "187ad006-1e9f-435b-95d7-7882ce11ac98",
  BUSINESS_MONTH: "b46f884b-50e8-49b4-9e49-459c7bcdddef",
  UNLIMITED_ANNUAL: "9980109c-4d2a-4f20-a985-a41f97c373a6",
  UNLIMITED_MONTH: "0c8f71db-5136-47d5-bb7c-9416a80da52f",
  ENTERPRISE: "5e8560cb-d43f-4df5-9c22-f2fd0ad765b0",
  SUGGEST_DEVICE: "c9b7b4a2-c1ec-447b-b218-0c2951ea8771",
  PRO_UPGRADE: "c481d03a-b256-47a6-acca-42acfbff8857",
};

export const DEVICE_TOUR = [
  {
    target: '[data-v-step="0"]',
    content: `You can filter the real devices you’re looking for.`,
  },
  {
    target: '[data-v-step="1"]',
    content: "You can switch between the views",
  },
  {
    target: ".v-step-2",
    content:
      "You can click “Launch“ to start using it and 'Device Info' to get the device details.",
    params: {
      placement: "top",
    },
  },
  {
    target: '[data-v-step="App"]',
    content: "You can manage and upload your mobile apps",
  },
];

export let PRICING = [
  {
    type: "pricing.plans.unlimited",
    price: 45,
    annualDiscount: 33,
    description: "pricing.plans.personal_use",
    isPopular: false,
    details: [
      "pricing.plans.unlimited_min",
      "pricing.plans.real_devices",
      "pricing.plans.mobile_web_app",
      "pricing.plans.upload_app",
      "pricing.plans.draw_ss",
      "pricing.plans.attendees",
    ],
  },
  {
    type: "pricing.plans.business",
    price: 150,
    annualDiscount: 10,
    description: "pricing.plans.mid_use",
    isPopular: true,
    details: [
      "pricing.plans.unlimited_min",
      "pricing.plans.real_devices",
      "pricing.plans.mobile_web_app",
      "pricing.plans.upload_app",
      "pricing.plans.draw_ss",
      "pricing.plans.attendees",
    ],
  },
  {
    type: "pricing.plans.enterprise",
    price: null,
    annualDiscount: null,
    description: "pricing.plans.large_use",
    isPopular: false,
    details: [
      "pricing.plans.plus",
      "pricing.plans.unlimited_user",
      "pricing.plans.ldap",
      "pricing.plans.sim",
      "pricing.plans.ip_white",
      "pricing.plans.custom",
    ],
  },
];
export const THEMES = {
  THEME: [
    {
      value: "system",
      text_theme: "settings.preferences.dark_mode.themes.system",
    },
    {
      value: "light",
      text_theme: "settings.preferences.dark_mode.themes.light",
    },
    { value: "dark", text_theme: "settings.preferences.dark_mode.themes.dark" },
  ],
};
export const PREF_LANG = {
  LANGUAGES: [
    {
      value: "en",
      text_lang: "settings.preferences.pref_language.languages.english",
    },
    {
      value: "tr",
      text_lang: "settings.preferences.pref_language.languages.turkish",
    },
  ],
};
